import {
  inject,
  Injectable,
} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {ApolloLink} from '@apollo/client';
import {
  CREATE_SHARED_LINK,
  SHARED_LINK,
} from '../queries/shared-link.query.model';
import {ApiGraphqlService} from '../../core/api-graphql/api-graphql.service';
import {ApiUrlService} from '../../core/api-url/api-url.service';
import {AnyObject} from '../../../../../models/object.model';

@Injectable({
  providedIn: 'root',
})
export class ApiSharedLinkService {

  private apiGraphqlService = inject(ApiGraphqlService);

  private apiUrlService = inject(ApiUrlService);

  private http = inject(HttpClient);

  /**
   * Method API: Create shared link for insurer interview comparison(used mutate)
   * @param payload
   * @param source
   */
  createSharedLinkDataObservable(payload: string, source: string): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.mutate(CREATE_SHARED_LINK, {payload, source});
  }

  /**
   * Method API: Get valuer for show shared link for insurer interview comparison(used query)
   * @param id
   */
  getSharedLinkDataObservable(id: string): Observable<ApolloLink.Result<AnyObject>> {
    return this.apiGraphqlService.query(SHARED_LINK, {id});
  }

  /**
   * Method API: Auth for shared link module
   */
  sharedLinkAuth(): Observable<any> {
    return this.http.get<any>(this.apiUrlService.sharedLinkAuthApiUrl);
  }

}
